import React, { useLayoutEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from '../context/AppContext';

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  // Прокручиваем в начало после рендера и анимаций
  useLayoutEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100); // Задержка 100ms — можно уменьшить или убрать

    return () => clearTimeout(timer); // Очистка таймера при размонтировании
  }, []);

  // Format the content to add bullet points before specific items
  const formatContent = (content) => {
    return content
      .split('\n')
      .map((line, index) => {
        if (line.includes('Notification Access') || 
            line.includes('Location (Coarse/Fine)') || 
            line.includes('Network Access') ||
            line.includes('Доступ к уведомлениям') ||
            line.includes('Местоположение (Грубое/Точное)') ||
            line.includes('Доступ к сети')) {
          return (
            <p key={index} className="flex items-start mt-2">
              <span className="font-bold text-lg mr-2">•</span>
              <span>{line}</span>
            </p>
          );
        }
        return <p key={index} className="mt-2">{line}</p>;
      });
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="pt-8 px-4 max-w-4xl mx-auto"
    >
      <h1 className="text-3xl font-bold mb-6 text-center">{t.privacyPolicyTitle}</h1>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6">
        <div className="whitespace-pre-wrap text-gray-800 dark:text-gray-200 font-sans">
          {formatContent(t.privacyPolicyContent)}
        </div>
      </div>
    </motion.div>
  );
}